var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import TwoEight from "./grid/12/TwoEight";
import Dash from "../icon/Dash";
import Box from "../box/Box";
export default (function (_a) {
    var label = _a.label, content = _a.content, _b = _a.withDash, withDash = _b === void 0 ? false : _b, dashColor = _a.dashColor, reverse = _a.reverse, rest = __rest(_a, ["label", "content", "withDash", "dashColor", "reverse"]);
    return (React.createElement(Box, __assign({}, rest),
        withDash && (React.createElement(TwoEight, { reverse: reverse, eight: React.createElement(Box, { px: 4 },
                React.createElement(Dash, { color: dashColor })), mb: label ? [2, 2, 2, 6] : [0, 0, 0, 6] })),
        React.createElement(TwoEight, { reverse: reverse, two: label && (React.createElement(Box, { px: 4, py: [0, 0, 0, 4] }, label)), eight: React.createElement(Box, { p: 4 }, content) })));
});
//# sourceMappingURL=LabelContent.js.map